import { Navigate } from "react-router-dom";
import { useAuth } from "./UseAuth";

const validateExpired = (dateNum: number | null) => {
  if (dateNum) {
    try {
      const now = new Date().getTime();
      return now - dateNum > 0;
    } catch (err) {
      return false;
    }
  }

  return false;
};
export const PrivateRoute = (props: any) => {
  const auth = useAuth();

  if (validateExpired(auth.expired ?? null)) {
    if (auth.logout) auth.logout();
  }

  // 渡された props をそのまま Route に設定する
  return <>{!auth.token ? <Navigate replace to="/login" /> : props.children}</>;
};
